import axios from 'axios';
import routes from '../../../../pages/routes';
import { AuthFormData, AuthLoginData } from '../types/AuthTypes';
import authMap from '../models/AuthMap';

const { apiURL } = routes;

const registerUser = (formData: AuthFormData): Promise<any> => {
  return axios.post(`${apiURL}auth/register`, formData);
};

const loginUser = (loginData: AuthLoginData): Promise<any> => {
  return axios.post(`${apiURL}auth/login`, loginData);
};

const logOut = () => {
  Object.keys(authMap).map((key) => localStorage.removeItem(key));
};

export { registerUser, loginUser, logOut };
